import { PetitionType } from "@nemuru-eng/js-api-client";
import { assetTypes } from "../../components/shared/config";

export const PatchAssetDetailsByLoanId = {
  dehydrate(data) {
    const formattedData = {
      op: "processPatchAssetDetailsByLoanId",
      id: data.loanId,
      asset_type: data.assetType,
    };
    let assetDetails = {};
    switch (data.assetType) {
      case assetTypes.UTILITIES_SUPPLY:
        assetDetails["cups"] = data.cups.replace(/\s/g, "").toUpperCase();
        break;
      case assetTypes.CARD:
        assetDetails["petition_type"] = PetitionType.BORROWER;
        assetDetails["brand"] = "WY";
        assetDetails["payment_mode"] = data.paymentMode;
        assetDetails["is_pre_card_requested"] = false; //TODO: Remove this once the backend is updated
        assetDetails["monthly_statement_day"] = 30; //TODO: Remove this once the backend is updated
        if (data.fixedInstalmentAmount) {
          assetDetails["fixed_instalment_amount"] = data.fixedInstalmentAmount;
        }
        break;
      default:
        break;
    }
    formattedData["asset_details"] = assetDetails;
    return formattedData;
  },
};
